module.exports = __webpack_public_path__ + "img/weather_.605c2e71.png";